export default "__VITE_ASSET__Ce4dp_Gb__"